module.exports = __webpack_public_path__ + "static/media/20201129_210823_793_IMG_1829.b08bef6a.jpg";